// Meta Pixel: caricato solo con consenso marketing (iubenda, finalità 5) e solo sulle pagine pubbliche, registrazione e dashboard.
const PIXEL_ID = '1474847687843962';
const MARKETING_PURPOSE = '5';
const EXCLUDED_PREFIXES = ['/app', '/preview/app', '/admin', '/admin-private-control', '/scudo', '/stazione', '/stazione-digitale', '/stazione-successo', '/invito', '/join-family'];

export const isTrackedPath = (path) => !EXCLUDED_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));

const consentFromCookie = () => {
  const raw = document.cookie.split('; ').find((c) => c.startsWith('_iub_cs-'));
  if (!raw) return false;
  try {
    const prefs = JSON.parse(decodeURIComponent(raw.split('=').slice(1).join('=')));
    return prefs.purposes ? prefs.purposes[MARKETING_PURPOSE] === true : prefs.consent === true;
  } catch (e) {
    return false;
  }
};

export const hasMarketingConsent = () => {
  try {
    const prefs = window._iub?.cs?.api?.getPreferences?.();
    if (prefs?.purposes) return prefs.purposes[MARKETING_PURPOSE] === true;
  } catch (e) {
    // iubenda non pronto: si legge il cookie
  }
  return consentFromCookie();
};

let pixelInitialised = false;

const loadPixel = () => {
  // fbq puo' gia' esistere senza essere inizializzato (es. stub di iubenda):
  // ci si basa su un flag nostro, non sulla presenza di fbq.
  if (pixelInitialised) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
  pixelInitialised = true;
};

// true se l'evento è partito (consenso presente e pagina tracciata)
const track = (event, params, eventId) => {
  if (!isTrackedPath(window.location.pathname) || !hasMarketingConsent()) return false;
  loadPixel();
  window.fbq('track', event, params || {}, eventId ? { eventID: eventId } : undefined);
  return true;
};

export const trackPageView = () => track('PageView');

// Google Analytics: stesso consenso marketing del Pixel e stesse pagine escluse; mai caricato né attivo su pagine sensibili
const GA_ID = 'G-TQ2HEEMV43';

// Flag ufficiale di Google: blocca ogni invio (anche le pagine viste automatiche) mentre si è su una pagina esclusa
export const setAnalyticsAllowed = (path) => {
  window[`ga-disable-${GA_ID}`] = !isTrackedPath(path);
};

export const loadAnalytics = () => {
  if (window.__curacheckGA || !hasMarketingConsent() || !isTrackedPath(window.location.pathname)) return false;
  window.__curacheckGA = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
  return true;
};

export const trackLead = (famigliaId) => track('Lead', {}, `lead-${famigliaId}`);

export const trackPurchase = (sessionId, value, currency) => {
  const key = `curacheck_fb_purchase_${sessionId}`;
  if (localStorage.getItem(key)) return false;
  const sent = track('Purchase', { value, currency }, `purchase-${sessionId}`);
  if (sent) localStorage.setItem(key, '1');
  return sent;
};
